import { render, staticRenderFns } from "./ZhiZe.vue?vue&type=template&id=0d798a8c&scoped=true&"
import script from "./ZhiZe.vue?vue&type=script&lang=js&"
export * from "./ZhiZe.vue?vue&type=script&lang=js&"
import style0 from "./ZhiZe.vue?vue&type=style&index=0&id=0d798a8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d798a8c",
  null
  
)

export default component.exports